module.exports = __webpack_public_path__ + "static/img/xwsj.c2c9038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xwsj.png
// module id = n8J7
// module chunks = 0